import Vue from 'vue';

import Module from '@/scripts/old/classes/Module';
import Analytics from '@/scripts/old/helpers/Analytics';
import { parseAttr } from '@/scripts/old/helpers/utils';

import Game from './Fifa2018Game.vue';

const NAMESPACE = 'data-fifa2018game';

class Fifa2018GamesModule extends Module {
  constructor() {
    super(`[${NAMESPACE}]`);
  }

  initInstance(el) {
    const mountingPoint = document.createElement('div');
    el.appendChild(mountingPoint);

    const config = parseAttr(el, NAMESPACE);

    const game = new Vue({
      el: mountingPoint,
      render(h) {
        return h(Game, {
          props: {
            team: config.team,
            teams: config.teams,
            attempts: config.attempts,
            attemptsDone: config.attemptsDone,
            lastResult: config.lastResult,
            points: config.points,
            resultSaved: config.resultSaved,
            endpoint: config.endpoint,
            saveUrl: config.saveUrl,
            ratingsUrl: config.ratingsUrl,
            lang: config.lang,
          },
          on: {
            selectTeam() {},
            play({ attempt }) {
              if (attempt === 1) {
                Analytics.reachGoal('RouletteTry1');
              } else if (attempt === 2) {
                Analytics.reachGoal('RouletteTry2');
              }
            },
            playAgain() {},
            pass() {},
          },
        });
      },
    });

    this.instances.set(el, game);
  }

  destroyInstance(instance) {
    instance.$destroy();
    instance.$el.parentElement.removeChild(instance.$el);
  }
}

export default new Fifa2018GamesModule();
